<template>
  <div class="c-cover-name-code" :class="{
    'c-cover-name-code--ml-offset': mlOffset,
    'c-cover-name-code--off-shelf': offShelfConfig.used && !isOnShelfStatus,
  }">
    <router-link class="c-cover-name-code__img" :to="`/explore/albums-info/${data.albumUid || data.album?.albumUid}`"
      @click.stop>
      <div class="c-cover-name-code__img__mask"></div>
      <img class="c-cover-name-code__img__icon" src="@/assets/mobile/icon_menu_info_red.svg" />
      <img class="c-cover-name-code__img__cover" :src="imageSource(data.artworkInfo || data.cover)" />
    </router-link>

    <p class="c-cover-name-code__info">
      <span class="c-cover-name-code__info__name">{{
        data.trackTitleDisplay || data.title || data.albumTitleDisplay || data.name
      }}</span>
      <span class="c-cover-name-code__info__code">{{ data.albumCode || data.album?.albumCode }}{{
        data.trackNumber ?
          `-${data.trackNumber}` : ''
      }}</span>
    </p>
  </div>
</template>
<script>
import {
  defineComponent,
  // computed
} from 'vue';
// import { useMusicPlayerStore } from '@/store/musicPlayer';
import imageSource from '@/utils/imageSource';
import useIsOffShelf from '@/hooks/useIsOffShelf';

export default defineComponent({
  name: 'CoverNameCode',
  props: {
    mlOffset: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object,
      default: () => { },
    },
    offShelfConfig: {
      type: Object,
      default: () => ({
        used: false, // 是否要顯示下架資訊
        type: 'TRACK',
      }),
    },
  },
  setup(props) {
    // const musicPlayerStore = useMusicPlayerStore();
    const { isOnShelfStatus } = useIsOffShelf(props);

    return {
      imageSource,
      // info: computed(() => musicPlayerStore.info),
      isOnShelfStatus,
    };
  },
});
</script>
<style lang="scss" scoped>
.c-cover-name-code {
  @include flex();

  &--ml-offset {
    margin-left: -16px;
  }

  &--off-shelf {
    .c-cover-name-code__img {
      position: relative;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;

      &__mask {
        display: block;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;

        &::after {
          content: '';
          @include position(center);
          width: 100%;
          height: 100%;
          display: inline-block;
          background-color: rgba($c-black, 0.5);
          border-top-left-radius: 5px;
          border-bottom-left-radius: 5px;
        }
      }

      &__icon {
        display: inline-block;
        width: 20px;
        @include position(center);
      }
    }
  }

  &__img {
    width: 52px;
    height: 52px;

    &__mask {
      display: none;
    }

    &__icon {
      display: none;
    }

    &__cover {
      width: 52px;
      height: 52px;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
  }

  &__info {
    margin-left: 16px;
    @include flex(flex-start, flex-start, column);

    &__name {
      text-align: left;
      @include font-style($c-assist6, 14, bold, 0.8px, 18px);
      @include word-ellipsis(1);
    }

    &__code {
      text-align: left;
      @include font-style($c-assist4, 14, 400, 0.8px, 18px);
      @include word-ellipsis(1);
    }
  }
}
</style>
